import { InventoryDTO } from "../DTO/inventoryDTO";

export class StoreInventoryBulkRequest{
    public userId!:string;
    public businessId!:string;
    public inventory:InventoryDTO[]=[];
}